import Form from "discourse/form-kit/components/fk/form";
export default Form;
